import createVueComponent from '../createVueComponent';

const SmartphoneCharging = createVueComponent('SmartphoneChargingIcon', [
  [
    'rect',
    {
      width: '14',
      height: '20',
      x: '5',
      y: '2',
      rx: '2',
      ry: '2',
      key: '1yt0o3',
    },
  ],
  ['path', { d: 'M12.667 8 10 12h4l-2.667 4', key: 'h9lk2d' }],
]);

export default SmartphoneCharging;
